@if (formGroup.get(property.Key) && !isRadioButton) {
  <mat-form-field [formGroup]="formGroup" [subscriptSizing]="showErrors ? 'fixed' : 'dynamic'" class="flex-form-field">
    @if (showLabel) {
      <mat-label [attr.for]="property.key">{{ property.TextId | translate }}</mat-label>
    }
    <mat-select [formControlName]="property.Key" [matTooltip]="toolTipTextId | translate">
      @for (propertyItem of property.Items; track propertyItem.Value) {
        <mat-option [value]="propertyItem.Value">
          {{ propertyItem.TextId ? (propertyItem.TextId | translate) : propertyItem.Name ? propertyItem.Name : propertyItem.Value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
<!-- mat radio button is not supported in mat form field -->
@if (formGroup.get(property.Key) && isRadioButton) {
  <form [formGroup]="formGroup">
    <mat-label [attr.for]="property.key">{{ property.TextId | translate }}</mat-label>
    <mat-radio-group [formControlName]="property.Key" [matTooltip]="toolTipTextId | translate">
      @for (propertyItem of property.Items; track propertyItem.Value) {
        <mat-radio-button [value]="propertyItem.Value">
          {{ propertyItem.TextId ? (propertyItem.TextId | translate) : propertyItem.Name ? propertyItem.Name : propertyItem.Value }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </form>
}
